import React, { FC } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { IGatsbyImageData } from 'gatsby-plugin-image';

import { NavbarV2 as Nav } from '@bitcoin-portal/navbar';
import Footer from '@bitcoin-portal/footer';

import H1 from '@bitcoin-portal/bitcoincom-pkg-components/dist/H1';
import Paragraph from '@bitcoin-portal/bitcoincom-pkg-components/dist/Paragraph';
import ContentBlock from '@bitcoin-portal/bitcoincom-pkg-components/dist/ContentBlock';
import Section from '@bitcoin-portal/bitcoincom-pkg-components/dist/Section';
import Link from '@bitcoin-portal/bitcoincom-pkg-components/dist/Link';

import Image from '../../components/Image';

import { appLocales } from '../../i18n';

interface Props {
  image: IGatsbyImageData | string;
}

const View: FC<Props> = ({ image }) => {
  const { formatMessage, locale } = useIntl();

  return (
    <>
      <Nav locale={locale} />
      <Section>
        <ContentBlock
          aside={
            <Image
              image={image}
              alt={formatMessage({ id: 'home.content.title' })}
            />
          }
        >
          <H1>
            <FormattedMessage id="home.content.title" />
          </H1>
          <Paragraph>
            <FormattedMessage id="home.content.subtitle" />
          </Paragraph>
          <Paragraph>
            <FormattedMessage
              id="home.content.action"
              values={{
                home: (
                  <Link href="/">
                    <FormattedMessage id="home.content.action_home" />
                  </Link>
                ),
                contact: (
                  <Link href="mailto:contact@bitcoin.com">
                    <FormattedMessage id="home.content.action_contact" />
                  </Link>
                ),
              }}
            />
          </Paragraph>
        </ContentBlock>
      </Section>
      <Footer locale={locale} localeList={Object.keys(appLocales)} />
    </>
  );
};

export default View;
